import {
  CreateTaskBody,
  NewTaskDataModel,
  Note,
  RealtimeRoomsColumn,
  RoomCleanSummary,
  RoomCleanTask,
  RoomCleanTaskList,
  RoomCleanTaskStatus,
  Task,
  TaskAssigneeVM,
  TaskDetailsPayload,
  TaskFilter,
  TaskStatusUpdatedData,
} from '@app/core/async-services/http/versioned/task-management/task-management.interface';
import { createAction, props } from '@ngrx/store';
import { HotelType } from '@app/core/async-services/http/versioned/interfaces/users.interface';
import { Hotel } from '@app/core/models/user.interface';
import {
  AssigneeWorkingStatusUpdate,
  RealtimeRoomsStatus,
} from '@app/core/async-services/http/versioned/housekeeping/housekeeping.interface';

export const deleteTaskButtonClicked = createAction(
  '[Tasks] Delete Task Button Clicked',
);

export const deleteTaskSucceeded = createAction(
  '[Tasks] Delete Task Succeeded',
  props<{ id: string }>(),
);

export const assigneeSaveButtonClicked = createAction(
  '[Tasks] Assignee Save Button Clicked',
  props<{ assignee: TaskAssigneeVM }>(),
);

export const editAssigneeSucceeded = createAction(
  '[Tasks] Edit Assignee Succeeded',
  props<{ id: string; task: Task }>(),
);

export const editAssigneeFailed = createAction('[Tasks] Edit Assignee Failure');

export const tasksInitialized = createAction('[Tasks] Initialized');

export const defaultTaskMenuDetermined = createAction(
  '[Tasks] Default Menu Determined',
  props<{ hotel: Hotel; taskFilter: TaskFilter }>(),
);

export const getTaskListSucceeded = createAction(
  '[Tasks] Get Task List Succeeded',
  props<{
    taskList: Task[];
  }>(),
);

export const tasksMenuDoneButtonClicked = createAction(
  '[Tasks] Menu Modal - Done Button Clicked',
  props<{ hotel: HotelType; taskFilter: TaskFilter }>(),
);

export const moveBackToInProgressButtonClicked = createAction(
  '[Tasks] Move Back To In Progress Button Clicked',
);

export const moveBackToOpenButtonClicked = createAction(
  '[Tasks] Move Back To Open Button Clicked',
);

export const homePageCreateTaskButtonClicked = createAction(
  '[Tasks] Home Page - Create Task Button Clicked',
);

export const getTaskDetailsSucceeded = createAction(
  '[Tasks] Get Task Details Succeeded',
  props<{ payload: TaskDetailsPayload }>(),
);

export const getNewTaskDataSucceeded = createAction(
  '[Tasks] Get New Task Data Succeeded',
  props<{
    newTaskData: NewTaskDataModel;
  }>(),
);

export const channelServiceForTasksInitialized = createAction(
  '[Tasks] Channel Service For Tasks Initialized',
);

export const channelServiceForRoomCleanTasksInitialized = createAction(
  '[Tasks] Channel Service For Room Clean Tasks Initialized',
);

export const pubNubTaskCreated = createAction(
  '[Tasks] PubNub - Task Created',
  props<{ task: Partial<Task> }>(),
);

export const pubNubTaskDeleted = createAction(
  '[Tasks] PubNub - Task Deleted',
  props<{ task: Partial<Task> }>(),
);

export const pubNubTaskUpdated = createAction(
  '[Tasks] PubNub - Task Updated',
  props<{ task: Partial<Task> }>(),
);

export const pubNubRoomCleanTaskCreated = createAction(
  '[Tasks] PubNub - Room Clean Task Created',
  props<{ task: Partial<Task> }>(),
);

export const pubNubRoomCleanTaskDeleted = createAction(
  '[Tasks] PubNub - Room Clean Task Deleted',
  props<{ task: Partial<Task> }>(),
);

export const pubNubRoomCleanTaskUpdated = createAction(
  '[Tasks] PubNub - Room Clean Task Updated',
  props<{ task: Partial<Task> }>(),
);

export const getTaskInboxChannelSucceeded = createAction(
  '[Tasks] Get Task Inbox Channel Succeeded',
  props<{ channel: string }>(),
);

export const getTaskInboxChannelFailed = createAction(
  '[Tasks] Get Task Inbox Channel Failed',
  props<{ message: string | undefined }>(),
);

export const getRoomCleanTaskInboxChannelSucceeded = createAction(
  '[Tasks] Get Room Clean Task Inbox Channel Succeeded',
  props<{ channel: string }>(),
);

export const getRoomCleanTaskInboxChannelFailed = createAction(
  '[Tasks] Get Room Clean Task Inbox Channel Failed',
  props<{ message: string | undefined }>(),
);

export const newTaskPageCreateTaskButtonClicked = createAction(
  '[Tasks] New Task Page - Create Task Button Clicked',
  props<{ body: CreateTaskBody }>(),
);

export const createTaskSucceeded = createAction(
  '[Tasks] Create Task Succeeded',
  props<{ task: Task }>(),
);

export const createTaskFailed = createAction('[Tasks] Create Task Failed');

export const startProgressButtonClicked = createAction(
  '[Tasks] Start Progress Button Clicked',
);

export const updateTaskStatusToInProgressSucceeded = createAction(
  '[Tasks] Update Task Status To In Progress Success',
  props<{ id: string; updatedTaskStatusData: TaskStatusUpdatedData }>(),
);

export const markAsDoneButtonClicked = createAction(
  '[Tasks] Mark As Done Button Clicked',
);

export const doneButtonClicked = createAction('[Tasks] Done Button Clicked');

export const updateTaskStatusToDoneSucceeded = createAction(
  '[Tasks] Update Task Status To In Progress Succeeded',
  props<{ id: string; updatedTaskStatusData: TaskStatusUpdatedData }>(),
);

export const updateTaskStatusToOpenSucceeded = createAction(
  '[Tasks] Update Task Status To Open Succeeded',
  props<{ id: string; updatedTaskStatusData: TaskStatusUpdatedData }>(),
);

export const updateTaskStatusActionSheetOptionClicked = createAction(
  '[Tasks] Update Task Status Action Sheet Option Clicked',
  props<{ statusType: RoomCleanTaskStatus }>(),
);

export const updateTaskStatusFailed = createAction(
  '[Task Management Http] Update Task Status Failed',
);

export const menuModalCanceled = createAction('[Tasks] Menu Modal Canceled');

export const viewTaskPageEntered = createAction(
  '[Tasks] View Task Page Entered',
);

export const realtimeRoomsInitialized = createAction(
  '[Realtime Rooms] Initialized',
);

export const defaultRealtimeRoomsMenuDetermined = createAction(
  '[Realtime Rooms] Default Menu Determined',
  props<{ hotel: Hotel }>(),
);

export const realtimeRoomsMenuSubmitted = createAction(
  '[Realtime Rooms] Menu Submitted',
  props<{ hotel: Hotel }>(),
);

export const getRoomCleanTaskListSucceeded = createAction(
  '[Tasks] Get Room Clean Task List Succeeded',
  props<{ taskList: RoomCleanTaskList; summary: RoomCleanSummary }>(),
);

export const getRoomCleanTaskListFailed = createAction(
  '[Tasks] Get Room Clean Task List Failed',
  props<{ error: any }>(),
);

export const viewRoomCleanTaskPageInitialized = createAction(
  '[Tasks] View Room Clean Task PageInitialzed',
);

export const realtimeRoomsPortfolioHotelClicked = createAction(
  '[Tasks] Realtime Rooms Portfolio Hotel Clicked',
  props<{ hotel: Hotel }>(),
);

export const roomCleanTaskStatusSaveButtonClicked = createAction(
  '[View Room Clean Task] Task Status Save Button Clicked',
  props<{ taskStatusId: string }>(),
);

export const pmsStatusSaveButtonClicked = createAction(
  '[View Room Clean Task] PMS Status Save Button Clicked',
  props<{ roomStatusId: string }>(),
);

export const changeLinenSaveButtonClicked = createAction(
  '[View Room Clean Task] Change Linen Save Button Clicked',
  props<{ changeLinen: boolean }>(),
);

export const roomCleanAssigneeSaveButtonClicked = createAction(
  '[View Room Clean Task] Assignee Save Button Clicked',
  props<{ assigneeId: string; assigneeTypeId: string }>(),
);

export const updatePMSStatusSucceeded = createAction(
  '[Housekeeping Http] Update PMS Status Succeeded',
  props<{
    taskId: string;
    roomStatusId: string;
    currentUser: { id: string; firstName: string; lastName: string };
  }>(),
);

export const updatePMSStatusFailed = createAction(
  '[Housekeeping Http] Update PMS Status Failed',
);

export const updateChangeLinenSucceeded = createAction(
  '[Housekeeping Http] Update Change Linen Succeeded',
  props<{
    taskId: string;
    changeLinen: boolean;
    currentUser: { id: string; firstName: string; lastName: string };
  }>(),
);

export const updateChangeLinenFailed = createAction(
  '[Housekeeping Http] Update Change Linen Failed',
);

export const updateRoomCleanTaskAssigneeSucceeded = createAction(
  '[Task Management Http] Update Room Clean Task Assignee Succeeded',
  props<{ task: RoomCleanTask }>(),
);

export const updateRoomCleanTaskAssigneeFailed = createAction(
  '[Task Management Http] Update Room Clean Task Assignee Failed',
);

export const updateTaskStatusSucceeded = createAction(
  '[Task Management Http] Update Task Status Succeeded',
  props<{ taskId: string; payload: TaskStatusUpdatedData }>(),
);

export const fetchRealtimeRoomsStatusSucceeded = createAction(
  '[Realtime Rooms] Fetch Status Succeeded',
  props<{ status: RealtimeRoomsStatus }>(),
);

export const fetchRealtimeRoomsStatusFailed = createAction(
  '[Realtime Rooms] Fetch Status Failed',
);

export const pubNubAssigneeWorkingStatusUpdated = createAction(
  '[PubNub] Assignee Working Status Updated',
  props<{ assignee: AssigneeWorkingStatusUpdate }>(),
);

export const dndSignStillOnConfirmationButtonClicked = createAction(
  '[View Room Clean Task] DND Sign Still On Confirmation Button Clicked',
);

export const saveNoteclicked = createAction(
  '[Tasks] Save Note Clicked',
  props<{ value: string; id: string | null }>(),
);

export const createOrEditTaskNoteSucceeded = createAction(
  '[Tasks] Create Or Edit Task Note Succeeded',
  props<{ note: Note; taskId: string | null }>(),
);

export const createOrEditTaskNoteFailed = createAction(
  '[Tasks] Create Or Edit Task Note Failed',
);

export const roomCleanTaskNoteViewed = createAction(
  '[View Room Clean Task] Room Clean Task Note Viewed',
  props<{ id: string }>(),
);

export const realtimeRoomsViewChanged = createAction(
  '[Realtime Rooms] Realtime Rooms View Changed',
  props<{ view: 'list' | 'roomAttendant' | 'summary' }>(),
);

export const realtimeRoomsListViewSortChanged = createAction(
  '[Realtime Rooms] List View Sort Changed',
  props<{ column: RealtimeRoomsColumn }>(),
);
